const endpoint = '/api/properties';

export default ['api', function(api) {
  return {
    save: property => {
      let url = property.id ? `${ endpoint }/${ property.id }` : endpoint;

      return api.upload(url, property).then(response => response.data);
    },
    delete: id => api.delete(`${ endpoint }/${ id }`),
    findAll: (page = undefined, perpage = undefined, deleted = undefined) => {
      return api.get(endpoint+(page ? '?page='+(page)+ (page > -1 ? '&perpage='+(perpage || '20') : '') : '')+(deleted ? '&deleted=true' : '')).
        then(response => response.data);
    },
    findById: id => {
      return api.get(`${ endpoint }/${ id }`)
        .then(response => response.data);
    }
  };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/services/properties.finance.service.js